import { post } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const createModule = (
  id: string,
  title: string,
  position: number,
  available_at: string
): Promise<AxiosResponse> =>
  post('/courses/modules', {
    course_id: id,
    title,
    position,
    available_at,
  })
